var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BaseResults } from '../../base-results';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { Router } from 'aurelia-router';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { I18N } from 'aurelia-i18n';
import { ClientHotLotteriesClientService } from '../../../../../services/modules/client/client-hot-lotteries-client.service';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results(router, lotteryClientService, lookupClientService, i18N, tokenClient, hotLotteryClientService, notificationClientService, dialogClientService) {
        return _super.call(this, router, lotteryClientService, lookupClientService, i18N, hotLotteryClientService, tokenClient, notificationClientService, dialogClientService) || this;
    }
    Results.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Results.prototype.showResults = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "lotteries-result-title",
                "lotteries-result-lotteries-combobox-label",
                "lotteries-result-date-combobox-label",
                "lotteries-result-button",
                "lotteries-result-more-prize-breakdown-title",
                "lotteries-result-more-prize-breakdown-table-prize-level",
                "lotteries-result-more-prize-breakdown-table-match",
                "lotteries-result-more-prize-breakdown-table-value",
                "lotteries-result-more-overview-title",
                "lotteries-result-more-draw-details-title",
                "lotteries-result-more-draw-details-table-schedule",
                "lotteries-result-more-draw-details-table-select",
                "lotteries-result-more-draw-details-table-jackpot",
                "lotteries-result-more-draw-details-table-tax",
                "lotteries-result-more-draw-details-weekly",
                "lotteries-result-more-draw-details-no-tax",
                "lotteries-result-bottom-text",
                "most-recent-label",
                "no-winner",
                "all-lotteries-label",
                "monday-text",
                "tuesday-text",
                "wednesday-text",
                "thursday-text",
                "friday-text",
                "saturday-text",
                "sunday-text",
                //Colors
                "lotteries-title",
                "lotteries-combobox-label-foreground",
                "lotteries-combobox-border",
                "lotteries-combobox-background",
                "lotteries-combobox-foreground",
                "lotteries-combobox-icon",
                "lotteries-lottery-background",
                "lotteries-lottery-border",
                "lotteries-lottery-name-foreground",
                "lotteries-lottery-country-foreground",
                "lotteries-lottery-number-border",
                "lotteries-lottery-number-background",
                "lotteries-lottery-number-foreground",
                "lotteries-lottery-bonus-number-background",
                "lotteries-lottery-bonus-number-foreground",
                "lotteries-lottery-prize-foreground",
                "lotteries-lottery-button-foreground",
                "lotteries-lottery-button-hover-foreground",
                "lotteries-lottery-button-background",
                "lotteries-lottery-button-hover-background",
                "lotteries-lottery-next-draw-foreground",
                "lotteries-lottery-result-details-expand-icon-color",
                "lotteries-lottery-result-details-background",
                "lotteries-lottery-result-details-border",
                "lotteries-lottery-result-details-foreground",
                "bottom-description",
            ]
        }, window.parent.location.origin);
    };
    Results.prototype.showHottestLotteries = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "hottest-lotteries-title",
                "hottest-lotteries-remaning-time",
                "hottest-lotteries-remaning-days",
                "hottest-lotteries-remaning-hours",
                "hottest-lotteries-remaning-minutes",
                "hottest-lotteries-button",
                //Colors
                "hottest-lotteries-title-foreground",
                "hottest-lotteries-background",
                "hottest-lotteries-details-foreground",
                "hottest-lotteries-details-digits-background",
                "hottest-lotteries-details-digits-foreground",
                "hottest-lotteries-prize-currency-foreground",
                "hottest-lotteries-prize-amount-foreground",
                "hottest-lotteries-prize-button-background",
                "hottest-lotteries-prize-button-foreground"
            ]
        }, window.parent.location.origin);
    };
    Results = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, LookupClientService, I18N, TokenClient,
            ClientHotLotteriesClientService, NotificationClientService, DialogClientService])
    ], Results);
    return Results;
}(BaseResults));
export { Results };
